<template>
  <div>
    <template>
      <h4
          class="not-margin"
          :style="{
          fontWeight: 'bold',
          color: '#195BFF',
          fontSize: '18px',
          marginTop: '10px',
        }"
      >
        <i
            class="fal fa-info-circle"
            :style="{ width: '30px', fontSize: '18px' }"
        ></i>
        {{ $t('generalCustomer.register_customer_title') }}
      </h4>
    </template>

    <!-- customer_name -->
    <div class="field column">
      <div class="control">
        <label class="label">
          {{ $t('generalCustomer.name') }}
          <span class="text-danger">* {{ errors.first("name") }}</span>
          <span class="text-danger">
              {{ server_errors.name }}
            </span>
        </label>
        <input
            class="input"
            type="text"
            name="name"
            :placeholder="$t('generalCustomer.placeholder_enter_first')"
            v-model="value.name"
            v-validate="'required|max:191'"
        />
      </div>
    </div>

    <!-- surname -->
    <div class="field column">
      <div class="control">
        <label class="label">
          {{ $t('generalCustomer.surname') }}
          <span class="text-danger"
          >* {{ errors.first("surname") }}</span
          >
          <span class="text-danger">
              {{ server_errors.surname }}
            </span>
        </label>
        <input
            class="input"
            type="text"
            name="surname"
            :placeholder="$t('generalCustomer.placeholder_enter_first')"
            v-model="value.surname"
            v-validate="'required|max:191'"
        />
      </div>
    </div>

    <!-- tel -->
    <div class="field column">
        <label class="label" style="text-align: left">
          {{ $t('generalCustomer.tel') }}
          <span class="text-danger">* {{ errors.first("tel") }}</span>
          <span class="text-danger">
            {{ server_errors.tel }}
          </span>
        </label>
        <div class="field has-addons">
          <p class="control">
            <span class="select">
              <select style="min-width: 80px" v-model="telType">
                <option value="020">020</option>
                <option value="030">030</option>
              </select>
            </span>
          </p>
          <p class="control" style="flex: auto">
            <input
                class="input"
                type="text"
                name="tel"
                placeholder="XXXXXXX..."
                v-model="value.tel"
                v-validate="{
                required: true,
                numeric: true,
                max: telType === '020' ? 8 : 7,
                min: telType === '020' ? 8 : 7,
              }"
            />
          </p>
        </div>
    </div>

    <!-- password -->
    <div class="field column">
      <div class="control">
        <label class="label">
          {{ $t('generalCustomer.password') }}
          <span class="text-danger">* {{ errors.first("password") }}</span>
          <span class="text-danger">
              {{ server_errors.password }}
            </span>
        </label>
        <input
            autocomplete="off"
            class="input"
            type="password"
            name="password"
            :placeholder="$t('generalCustomer.placeholder_password')"
            v-model="value.password"
            v-validate="'required|max:191|min:6'"
        />
      </div>
    </div>
    <div ref="target" id="target" class="center">
      <div class="con-btns">
        <vs-button
            ref="button"
            flat
            @click="ValidateForm()"
            class="form-btn-loading"
        >{{ $t('generalCustomer.save_customer_button') }}
        </vs-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import {Validator} from "vee-validate";

export default {
  data() {
    return {
      active: false,
      isLoading: false,
      server_errors: {
        name: "",
        surname: "",
        tel: "",
        password: ""
      },
      value: {
        name: "",
        surname: "",
        tel: "",
        password: ""
      },
      telType: "020",
    };
  },
  methods: {
    ValidateForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.SaveItem();
        }
      });
    },
    SaveItem() {
      const loading = this.BtnLoading();
      this.$http
          .post("admin-add-customer", this.value)
          .then((res) => {
            if (res.data.success) {
              setTimeout(() => {
                loading.close();
                this.$emit("close");
                this.$emit("success");
                this.$notification.OpenNotification_AddItem_OnSuccess(
                    "top-right",
                    "dark",
                    3000
                );
              }, 300);
            }
          })
          .catch((error) => {
            loading.close();
            if (error.response.status === 422) {
              var obj = error.response.data.errors; // ໃຊ້ການລູບຂໍ້ມູນເພາະວ່າຂໍ້ມູນ errors ທີ່ສົ່ງມາຈາກ Server ນັ້ນເປັນ Array Object
              for (let [key, value] of Object.entries(obj)) {
                this.server_errors[key] = value[0];
              }
            }
          });
    },
    BtnLoading() {
      return this.$vs.loading({
        target: this.$refs.button,
        scale: "0.6",
        background: "primary",
        opacity: 1,
        color: "#fff",
      });
    },
  },
  watch: {
    "value.tel": function () {
      this.server_errors.tel = "";
    },
  },
  created() {
    const dict = {
      custom: {
        name: {
          required: `(${this.$t('validator.required')}...)`,
          max: `(${this.$t('validator.max_character', {max: 191})}...)`,
        },

        surname: {
          required: `(${this.$t('validator.required')}...)`,
          max: `(${this.$t('validator.max_character', {max: 191})}...)`,
        },

        tel: {
          required: `(${this.$t('validator.required')}...)`,
          numeric: `(${this.$t('validator.numeric')}...)`,
          max: (name, rules) => {
            return `(${this.$t('validator.limit_character', {length: rules[0]})}...)`;
          },
          min: (name, rules) => {
            return `(${this.$t('validator.limit_character', {length: rules[0]})}...)`;
          },
        },

        password: {
          required: `(${this.$t('validator.required')}...)`,
          max: `(${this.$t('validator.max_character', {max: 191})}...)`,
          min: `(${this.$t('validator.min_character', {min: 6})}...)`,
        },
      },
    };
    Validator.localize("en", dict);
  },
};
</script>
<style lang="scss" scoped>
</style>